import { ClientConfig, ProjectConfig } from "next-sanity";

export const config: ProjectConfig & ClientConfig = {
  dataset: (process.env.NEXT_PUBLIC_SANITY_DATASET as string) || "development",
  projectId: (process.env.NEXT_PUBLIC_SANITY_PROJECT_ID as string) || "",
  apiVersion: "2021-03-25",
  useCdn: process.env.NEXT_PUBLIC_SANITY_DATASET === "production",
};
